import api, { unwrap } from './client'
import type { PaginationFilters, Paginated, FailedJob, QueueStats } from '@/types/models'

export const queueMonitorApi = {
  stats(): Promise<QueueStats> {
    return unwrap(api.get<{ data: QueueStats }>('/queue-monitor/stats'))
  },

  async listFailedJobs(filters: PaginationFilters = {}): Promise<Paginated<FailedJob>> {
    const params: Record<string, number> = {}
    if (filters.page) params.page = filters.page
    if (filters.per_page) params.per_page = filters.per_page

    const { data } = await api.get<Paginated<FailedJob>>('/queue-monitor/failed-jobs', { params })
    return data
  },

  retryFailedJob(uuid: string): Promise<unknown> {
    return api.post(`/queue-monitor/failed-jobs/${uuid}/retry`)
  },

  deleteFailedJob(uuid: string): Promise<unknown> {
    return api.delete(`/queue-monitor/failed-jobs/${uuid}`)
  },

  clearRateLimitPause(): Promise<unknown> {
    return api.post('/queue-monitor/clear-rate-limit-pause')
  },
}
